// extracted by mini-css-extract-plugin
export var divider = "_fc-7";
export var itemsToggle = "_fc-8";
export var mergeModal = "_fc-1";
export var optionCard = "_fc-4";
export var radioGroup = "_fc-6";
export var radioOption = "_fc-0";
export var selected = "_fc-5";
export var shipmentOptions = "_fc-2";
export var tableOptions = "_fc-3";